var module = angular.module('octopusApp.infrastructure', []);

module.config(function($stateProvider) {

    $stateProvider.state('app.style-guide',{
        url :'/style-guide',
        templateUrl: 'infrastructure/style-guide/style_guide.html',
        controller: 'StyleGuideController',
        layout: {
            title: 'Live Style Guide',
            tab: null
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/infrastructure_module.js
// module id = 140
// module chunks = 1